import React from 'react';
import { Dropdown } from 'react-bootstrap';
import {
  SortIcon,
  DropdownDots,
  ToggleIconLeft,
} from '../../components/ui/icons';
import DeleteUserModal from "../../components/deleteUserModal";
import { getCookie } from '../../common/utils';
import { actions as modalActions } from '../../components/updateUserModal/updateUserSlice';
import { useDispatch } from 'react-redux';
import { EditUserProps } from '../../common/types/userTypes';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

const UserColumns = (handleReinvite: any) => {

  const dispatch: ThunkDispatch<EditUserProps, undefined, Action> = useDispatch();
  const onEditUser = (userData: EditUserProps): void => {
    dispatch(modalActions.showModal());
    dispatch(modalActions.setUserData(userData));
  }

  return React.useMemo<any>(
    () => [
      {
        accessorFn: (row) => `${row.roleId}`,
        id: 'roleId',
        header: (row) => (
          <div className='table-heading'>
            Role Type
            <span>
              <SortIcon />
            </span>
          </div>
        ),
        cell: (info) => info.getValue(),
        footer: (props) => props.column.id,
      },
      {
        accessorFn: (row) => `${row.name}`,
        accessorKey: 'name',
        header: (row) => (
          <div className='table-heading'>
            Name
            <span>
              <SortIcon />
            </span>
          </div>
        ),
        footer: (props) => props.column.id,
        cell: (row) => <div className='table-cell'>{row.getValue()}</div>,
      },
      {
        accessorFn: (row) => `${row.groupId}`,
        accessorKey: 'groupId',
        header: (row) => (
          <div className='table-heading'>
            Groups
            <span>
              <SortIcon />
            </span>
          </div>
        ),
        footer: (props) => props.column.id,
        cell: (row) => <div className='table-cell'>{row.getValue()}</div>,
      },
      {
        accessorFn: (row) => `${row.email}`,
        accessorKey: 'email',
        header: (row) => (
          <div className='table-heading'>
            Email
            <span>
              <SortIcon />
            </span>
          </div>
        ),
        footer: (props) => props.column.id,
        cell: (row) => <div className='table-cell'>{row.getValue()}</div>,
      },
      {
        accessorFn: (row) => `${row.status}`,
        accessorKey: 'Status',
        header: (row) => (
          <div className='table-heading'>
            Status
            <span>
              <SortIcon />
            </span>
          </div>
        ),
        footer: (props) => props.column.id,
        cell: (row) => <div className='table-cell'>{row.getValue()}</div>,
      },
      {
        accessorKey: 'actions',
        header: () => <span></span>,
        Cell: () => <ToggleIconLeft />,
        footer: (props) => props.column.id,
        enableColumnFilter: false,
        cell: ({ row }) => {    
          const userId: string = row?.original?.userId;
          const name: string = row?.original?.name;
          const groupName: string = row?.original?.groupName;
          const { email, groupId, name: userName, organization, phoneNo, roleId, userId: Id, status, isPasswordEnable } = row?.original;
          const userData = { email, groupId, userName, organization, phoneNo, roleId, Id, groupName, status, isPasswordEnable }
          const isCurrentUser = email === decodeURIComponent(getCookie("email"));

          return (
            <div className='actions-btns'>
              <Dropdown>
                <Dropdown.Toggle id='dropdowndots'>
                  <DropdownDots />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item>
                    <div onClick={() => onEditUser(userData)}>Edit</div>
                  </Dropdown.Item>
                  {!isCurrentUser &&
                    <Dropdown.Item>
                      <DeleteUserModal id={userId} name={name} />
                    </Dropdown.Item>
                  }
                  {status !== 'Active' &&
                    <Dropdown.Item>
                    <div onClick={() => handleReinvite(userData)}>Re-Invite</div>
                    </Dropdown.Item>
                  }
                </Dropdown.Menu>
              </Dropdown>
            </div>)
        },
      },
    ],
    []
  );
};

export default UserColumns;
